// Performance monitoring and optimization utilities

// Measure Core Web Vitals
export const measureCoreWebVitals = () => {
  // Only run in production
  if (process.env.NODE_ENV !== 'production') return;

  // Largest Contentful Paint (LCP)
  const observer = new PerformanceObserver((list) => {
    const entries = list.getEntries();
    const lastEntry = entries[entries.length - 1];
    console.log('LCP:', lastEntry.startTime);
  });
  observer.observe({ entryTypes: ['largest-contentful-paint'] });

  // First Input Delay (FID)
  const fidObserver = new PerformanceObserver((list) => {
    const entries = list.getEntries();
    entries.forEach((entry) => {
      console.log('FID:', entry.processingStart - entry.startTime);
    });
  });
  fidObserver.observe({ entryTypes: ['first-input'] });

  // Cumulative Layout Shift (CLS)
  let clsValue = 0;
  const clsObserver = new PerformanceObserver((list) => {
    const entries = list.getEntries();
    entries.forEach((entry) => {
      if (!entry.hadRecentInput) {
        clsValue += entry.value;
      }
    });
    console.log('CLS:', clsValue);
  });
  clsObserver.observe({ entryTypes: ['layout-shift'] });
};

// Preload critical resources
export const preloadCriticalResources = () => {
  const criticalResources = [
    '/inflatabletxlogo.svg',
    '/static/css/main.css'
  ];

  criticalResources.forEach(resource => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.href = resource;
    link.as = resource.endsWith('.css') ? 'style' : 'image';
    document.head.appendChild(link);
  });
};

// Optimize images with intersection observer
export const optimizeImages = () => {
  const images = document.querySelectorAll('img[data-src]');
  
  const imageObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        img.src = img.dataset.src;
        img.classList.remove('lazy');
        observer.unobserve(img);
      }
    });
  });

  images.forEach(img => imageObserver.observe(img));
};

// Defer non-critical JavaScript
export const deferNonCriticalJS = () => {
  const scripts = document.querySelectorAll('script[data-defer]');
  
  const loadScript = (script) => {
    const newScript = document.createElement('script');
    newScript.src = script.dataset.src;
    newScript.async = true;
    document.body.appendChild(newScript);
  };

  // Load after page load
  window.addEventListener('load', () => {
    setTimeout(() => {
      scripts.forEach(loadScript);
    }, 1000);
  });
};

// Initialize all performance optimizations
export const initPerformanceOptimizations = () => {
  measureCoreWebVitals();
  preloadCriticalResources();
  optimizeImages();
  deferNonCriticalJS();
};
